import React, { ReactNode } from "react";

import "./ProjectOverview.scss";

interface ProjectOverviewProps {
  challengeTitle?: string;
  challengeContent: string[];
  solutionTitle?: string;
  solutionContent: string[];
  metrics: { value: string; label: string }[];
  bulletsLeft?: ReactNode;
  bulletsRight?: ReactNode;
  bulletsLeftSecondTier?: ReactNode;
  bulletsRightSecondTier?: ReactNode;
  extraChallengeContent?: string[];
  extraSolutionContent?: string[];
  extraChallengeContentSecondTier?: string[];
  extraSolutionContentSecondTier?: string[];
}

export function ProjectOverview({
  challengeTitle = "The Challenge",
  challengeContent,
  solutionTitle = "The Solution",
  solutionContent,
  metrics,
  bulletsLeft,
  bulletsRight,
  extraChallengeContent,
  extraSolutionContent,
  bulletsLeftSecondTier,
  bulletsRightSecondTier,
  extraChallengeContentSecondTier,
  extraSolutionContentSecondTier,
}: ProjectOverviewProps) {
  return (
    <section className="projectOverview">
      <div className="overviewContainer">
        <div className="overviewGrid">
          {/* Left Column - Challenge */}
          <div className="overviewColumn">
            <h2 className="columnLabel">{challengeTitle}</h2>
            <h3 className="columnTitle">{challengeContent[0]}</h3>
            {challengeContent.slice(1).map((paragraph, index) => (
              <p key={index} className="columnParagraph">
                {paragraph}
              </p>
            ))}
            {bulletsLeft && <div>{bulletsLeft}</div>}
            {extraChallengeContent?.slice(0).map((paragraph, index) => (
              <p key={index} className="columnParagraph">
                {paragraph}
              </p>
            ))}
            {bulletsLeftSecondTier && <div>{bulletsLeftSecondTier}</div>}
            {extraChallengeContentSecondTier
              ?.slice(0)
              .map((paragraph, index) => (
                <p key={index} className="columnParagraph">
                  {paragraph}
                </p>
              ))}
          </div>

          {/* Right Column */}
          <div className="overviewColumn">
            <h2 className="columnLabel">{solutionTitle}</h2>
            <h3 className="columnTitle">{solutionContent[0]}</h3>
            {solutionContent.slice(1).map((paragraph, index) => (
              <p key={index} className="columnParagraph">
                {paragraph}
              </p>
            ))}
            {bulletsRight && <div>{bulletsRight}</div>}
            {extraSolutionContent?.slice(0).map((paragraph, index) => (
              <p key={index} className="columnParagraph">
                {paragraph}
              </p>
            ))}
            {bulletsRightSecondTier && <div>{bulletsLeftSecondTier}</div>}
            {extraSolutionContentSecondTier
              ?.slice(0)
              .map((paragraph, index) => (
                <p key={index} className="columnParagraph">
                  {paragraph}
                </p>
              ))}
          </div>
        </div>

        {/* Key Metrics */}
        <div className="overviewMetrics">
          {metrics.map((metric, index) => (
            <div key={index} className="metricItem">
              <div className="metricValue">{metric.value}</div>
              <div className="metricLabel">{metric.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
